import { useTranslation } from 'react-i18next';
import CustomModal from './customModal';
import { LinearCloseCirlce } from '../icons';

interface ApiErrorModalProps {
  visible: boolean;
  message: string;
  onClose: () => void;
  'data-testid'?: string;
}

const ApiErrorModal = ({
  visible,
  message,
  onClose,
  'data-testid': dataTestId = 'api-error-modal',
}: ApiErrorModalProps) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      data-testid={dataTestId}
      visible={visible}
      title={t('common:error')}
      subdescription={message}
      confirmText={t('common:ok')}
      icon={<LinearCloseCirlce />}
      onConfirm={onClose}
      onClose={onClose}
    />
  );
};

export default ApiErrorModal;
